import React from 'react';
import { Link } from 'react-router-dom';
import { Globe, Lock, ShieldCheck } from 'lucide-react';

const Footer = () => {
    return (
        <footer className="py-32 border-t border-neutral-200 dark:border-white/5 bg-zinc-100 dark:bg-[#030303] relative transition-colors duration-500">
            <div className="max-w-7xl mx-auto px-6">
                <div className="grid grid-cols-2 md:grid-cols-6 gap-16 mb-24">
                    <div className="col-span-2">
                        <div className="flex items-center gap-5 mb-8">
                             <img src="/logo.png" alt="Logo" className="w-16 h-16 grayscale hover:grayscale-0 transition-all cursor-pointer" />
                            <span className="text-4xl font-black tracking-tighter text-zinc-900 dark:text-white">ScholarsAnchor</span>
                        </div>
                        <p className="text-neutral-500 dark:text-zinc-500 text-lg leading-relaxed mb-8 font-medium max-w-sm">
                            The high-performance administrative platform for global academic excellence.
                        </p>
                        <div className="flex items-center gap-4">
                            {[Globe, Lock, ShieldCheck].map((Icon, i) => (
                                <div key={i} className="w-12 h-12 rounded-xl bg-white dark:bg-zinc-900 border border-neutral-200 dark:border-white/5 flex items-center justify-center hover:bg-zinc-50 dark:hover:bg-zinc-800 transition-all cursor-pointer group shadow-sm dark:shadow-none">
                                    <Icon className="w-5 h-5 text-neutral-500 group-hover:text-zinc-900 dark:group-hover:text-white" />
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="col-span-1">
                        <h4 className="text-zinc-900 dark:text-white font-black mb-6 tracking-widest uppercase text-xs">Product</h4>
                        <ul className="space-y-4 text-neutral-500 dark:text-zinc-500 text-sm font-bold">
                            {[
                                { name: 'Features', path: '/features' },
                                { name: 'Solutions', path: '/solutions' },
                                { name: 'Documentation', path: '/docs' },
                                { name: 'Benchrex', path: '/portal' },
                            ].map(item => (
                                <li key={item.name} className="hover:text-zinc-900 dark:hover:text-white transition-colors cursor-pointer">
                                    <Link to={item.path}>{item.name}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="col-span-1">
                        <h4 className="text-zinc-900 dark:text-white font-black mb-6 tracking-widest uppercase text-xs">Company</h4>
                        <ul className="space-y-6 text-neutral-500 dark:text-zinc-500 text-sm font-bold">
                            <li className="hover:text-zinc-900 dark:hover:text-white transition-colors cursor-pointer">
                                <Link to="/about">About</Link>
                            </li>
                            <li className="hover:text-zinc-900 dark:hover:text-white transition-colors cursor-pointer">
                                <Link to="/security">Security</Link>
                            </li>
                            <li className="group">
                                <a href="https://threnlabs.com" target="_blank" rel="noopener noreferrer" className="hover:text-zinc-900 dark:hover:text-white transition-colors block mb-4">Threnlabs</a>
                                <div className="flex flex-col gap-3">
                                    <img src="/threnlabs.svg" alt="Threnlabs" className="w-20 h-auto opacity-30 group-hover:opacity-100 transition-opacity" />
                                    <div className="text-[0.55rem] font-black uppercase tracking-[0.2em] text-neutral-500 dark:text-zinc-600 leading-tight">
                                        Product by threnlabs <br />
                                        All rights reserved
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div className="col-span-2">
                        <h4 className="text-zinc-900 dark:text-white font-black mb-6 tracking-widest uppercase text-xs">Stay Updated</h4>
                        <div className="flex gap-2">
                            <input
                                type="email"
                                placeholder="email@institution.edu"
                                className="bg-white dark:bg-zinc-900 border border-neutral-200 dark:border-white/5 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-blue-500 transition-all flex-1 text-zinc-900 dark:text-white shadow-sm dark:shadow-none"
                            />
                            <button className="bg-zinc-900 dark:bg-white text-white dark:text-black font-black px-6 py-3 rounded-xl text-sm hover:bg-zinc-800 dark:hover:bg-zinc-200 transition-all">
                                Join
                            </button>
                        </div>
                    </div>
                </div>

                <div className="flex flex-col md:flex-row items-center justify-between border-t border-neutral-200 dark:border-white/5 pt-12 text-neutral-500 dark:text-zinc-600 text-[0.65rem] font-black uppercase tracking-[0.3em]">
                    <p>© {new Date().getFullYear()} ScholarsAnchor Infrastructure. Built for the future.</p>
                    <div className="flex items-center gap-10 mt-6 md:mt-0">
                        <Link to="/privacy" className="hover:text-zinc-900 dark:hover:text-white transition-colors">Privacy</Link>
                        <Link to="/license" className="hover:text-zinc-900 dark:hover:text-white transition-colors">Legal</Link>
                    </div>
                </div>

            </div>
        </footer>
    );
};

export default Footer;
